"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _recordDetail = _interopRequireDefault(require("@/components/wareHouse/recordDetail.vue"));
var _recoredEdit = _interopRequireDefault(require("@/components/wareHouse/recoredEdit.vue"));
var _warehouse = require("@/api/warehouse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    RecordDetail: _recordDetail.default,
    RecoredEdit: _recoredEdit.default
  },
  data: function data() {
    return {
      search: {
        retDate: '',
        billNo: ''
      },
      list: [],
      listLoading: true,
      info: {},
      total: 0,
      pageNo: 1,
      pageSize: 10
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    onClear: function onClear() {
      this.search = {}, this.page = 1;
      this.getList();
    },
    // 返回列表
    returnList: function returnList() {
      this.$router.push('/wareHouse/productReturn');
    },
    // 查找
    onSearch: function onSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 仓库详情
    getDetail: function () {
      var _getDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(id) {
        var data, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _warehouse.listBillDetailApi)({
                inoutId: id
              });
            case 1:
              data = _context.v;
              res = data.data;
              if (res.errno == 0) {
                this.info = res.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    // 进入详情
    toDetail: function () {
      var _toDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(item) {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getDetail(item.inoutId);
            case 1:
              this.$refs.RecordDetail.open(this.info);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function toDetail(_x2) {
        return _toDetail.apply(this, arguments);
      }
      return toDetail;
    }(),
    // 修改
    toEdit: function () {
      var _toEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(item) {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.getDetail(item.inoutId);
            case 1:
              this.$refs.RecoredEdit.open(this.info, item.inoutId);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toEdit(_x3) {
        return _toEdit.apply(this, arguments);
      }
      return toEdit;
    }(),
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.search), {}, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      (0, _warehouse.listReturnDetailApi)(params).then(function (data) {
        var res = data.data;
        console.log(res);
        if (res.errno == 0) {
          _this.listLoading = false;
          _this.list = res.data.data.list;
          _this.total = res.data.data.total;
        }
      });
      this.total = 8;
    }
  }
};